export default "__VITE_ASSET__DEAtZhUA__"